export const GAME_TITLE = '字知之明'

export const WIN_MESSAGES = ['Good Job!', 'Awesome', 'Well done!']
export const GAME_COPIED_MESSAGE = '已複製到剪貼簿'
export const ABOUT_GAME_MESSAGE = '關於這個遊戲'
export const NOT_ENOUGH_LETTERS_MESSAGE = '字數不對'
export const WORD_NOT_FOUND_MESSAGE = '不在字單中'
export const CORRECT_WORD_MESSAGE = (solution: string) =>
  `答案是「${solution}」`
export const ENTER_TEXT = 'Enter'
export const DELETE_TEXT = 'Delete'
export const STATISTICS_TITLE = '統計'
export const GUESS_DISTRIBUTION_TEXT = '猜測數分佈'
export const NEW_WORD_TEXT = '下一場在'
export const SHARE_TEXT = '分享'
export const TOTAL_TRIES_TEXT = '總猜測數'
export const SUCCESS_RATE_TEXT = '成功率'
export const CURRENT_STREAK_TEXT = '目前連勝數'
export const BEST_STREAK_TEXT = '最佳連勝數'
export const RANDOM_GAME_TEXT = '隨機模式'
export const DAILY_GAME_TEXT = '每日關卡'
export const RANDOM_STATS_TEXT = '隨機關卡'
export const SWITCH_TO_RANDOM_CONFIRM_TEXT =
  '每日關卡尚未完成，確定要切換到隨機關卡嗎？'
